import React, {useEffect, useCallback, useRef, useState} from 'react'
import { Link } from 'react-router-dom'
import xButton from './../assets/xButton.png'
import deliveryPic from './../assets/delivery.png'
import goBack from './../assets/back.png'
import firebase from './../../config/fbConfig.js'
import cartPic from './../assets/cart.png'
import Cart from './cart';
import {Helmet} from "react-helmet";

const analytics = firebase.analytics();

 function MenuCategory(props) {
    const [chosenCategory, setChosenCategory] = useState([])
    const optionsCounter = useRef(0)
    const observerPics = useRef()

    let [cart, setCart] = useState({counter: 0, products: [], totalPrice: 0, times: []})
    const newProduct = useRef({name: null, options: [], extras: [], price: 0, totalPrice: 0, noDelivery: false})
    const successToastTimeout = useRef()
    const [, updateState] = React.useState(); // To force render
    const forceUpdate = useCallback(() => updateState({}), []); // Force render
    const lastMovedOver = useRef()

     useEffect(() => {
         if (props.chosenCategory!=null) { // If called from admin panel
            setChosenCategory(props.chosenCategory);
         } else { // If coming from menu (as regular user)
            setChosenCategory(props.history.location.state.chosenCategory);
            setCart(props.history.location.state.cart);
         } 

         const images = document.getElementsByClassName('productPic');

         setTimeout(() => {
            document.getElementById('chosenCategory').classList.add('active');
            document.getElementById('goBackMenu').classList.add('active');

            observerPics.current = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        entry.target.src = entry.target.dataset.src;
                        entry.target.classList.add('loaded');
                    }
                })
            })
            for (const image of images) {
                observerPics.current.observe(image);
            }
            
         }, 0);

		
        return () => {
            observerPics.current.disconnect();
        }
     }, [props.chosenCategory])
    
    // Used when trying to get zoom on a product inside a category
    let openEnlargedPic = (e) => {
        document.getElementById('popUpEnlargedImage').firstChild.firstChild.src = e.target.src;
        document.getElementById('popUpEnlargedImage').classList.add('active');
        if (!props.isAdmin) document.getElementById('brightnessBottom').classList.add('active');
    }
    // Used when closing the enlarged zoomed product's picture(see above)
    let closeEnlargedImage = () => {
        document.getElementById('popUpEnlargedImage').classList.remove('active');
        if (!props.isAdmin) document.getElementById('brightnessBottom').classList.remove('active');
    }
    // Used when the user wants to order this specific product, opening a box with the option add to cart
    let orderNow = (e) => {
        document.getElementById('brightnessLeft').classList.add('active');
        if (e.target.tagName==="IMG") {
            e.target.parentNode.nextSibling.classList.add('active');
        } else {
            e.target.nextSibling.classList.add('active');
        }
        closeSuccessToast();
    }
    // Used to remove the spaces of product names to put it inside element's id
    let getRemovedSpacesVal = (val, productName) => {
        val = val.replace(/\s/g, '');
        productName = productName.replace(/\s/g, '');
        return val + productName;
    }
    // Used when the user is closing the "Add to cart" box element(of extras/options, add to cart)
    let closeOrder = (e, val) => {
        optionsCounter.current = 0;
        document.getElementById('brightnessLeft').classList.remove('active');
        newProduct.current = {name: null, options: [], extras: [], price: 0, totalPrice: 0, noDelivery: false};
        
        // This is called with val only when clicking on "Add to cart"
        if (e != null) {          
            e.target.parentNode.parentNode.classList.remove('active');
            resetForm(e.target.nextSibling); // cant use form.reset() because afterwards onChange won't trigger, so doing it manually 1 by 1 unfortunatelly..
        } else {
            val.parentNode.parentNode.classList.remove('active');
            resetForm(val);
        }
    }
    let resetForm = (x) => {
        if (x.children[1].children[1].tagName=="LABEL") {
            let optionsLength = x.children[1].children.length;
            // Starting from 1 to skip the first element in options which is just the title Options
            for (let i = 1; i < optionsLength; i++) {
                x.children[1].children[i].children[0].checked = false;
            }
        }
        
        if (x.children[2].children[1].tagName=="LABEL") {
            let extrasLength = x.children[2].children.length;
            for (let i = 1; i < extrasLength; i++) {
                x.children[2].children[i].children[0].checked = false;
            }
        }

    }
    // Used to track the number of times the user picked an option, and to enforce it to not pass it
    let checkLimit = (e, name, max) => {
        if (e.target.checked) {
            optionsCounter.current++; // if optionsCounter=max so the user can't pick anymore
            newProduct.current.options.push(name); // Adding the chosen option to the array of new product
        } else {
            optionsCounter.current--;

            let index = newProduct.current.options.findIndex(i => i === name); // Removing the specific chosen option of the array of new product
            newProduct.current.options.splice(index, 1); 
        }
        
        if (optionsCounter.current > max) {
            optionsCounter.current--;
            e.target.checked = false;

            let index = newProduct.current.options.findIndex(i => i === name);
            newProduct.current.options.splice(index, 1); 
        }
    }
    // Used when a user picks extras in product, so adding the chosen extra to the new product Ref, in cane unchecked so removing it from the array
    let addExtras = (e, name, price) => {
        if (e.target.checked) {
            newProduct.current.extras.push({name: name, price: price});
            newProduct.current.totalPrice = +newProduct.current.totalPrice + +price;
            cart.totalPrice = +cart.totalPrice + +price;

        } else {
            let index = newProduct.current.extras.findIndex(i => i.name === name);
            newProduct.current.extras.splice(index, 1);
            newProduct.current.totalPrice = +newProduct.current.totalPrice - +price;
            cart.totalPrice = +cart.totalPrice - +price;
        }
    }
    // Used when a user clicks Add to cart
    let addProductToCart = (e, price, name, noDelivery) => {
        e.preventDefault();
        newProduct.current.price = price;
        newProduct.current.totalPrice = +newProduct.current.totalPrice + +price;
        newProduct.current.name = name; 
        newProduct.current.noDelivery = noDelivery;
        cart.totalPrice = +cart.totalPrice + +price;

        cart.counter++;;
        cart.products.push(newProduct.current);

        setCart(cart);
        closeOrder(null, e.target.parentNode);
        showSuccessToast();
        forceUpdate();

        // For events log - analytics
        // Getting the last added product, and logging this event
        let cartLog = Object.assign({}, cart.products[cart.products.length-1]);
        let arr = [];
        cartLog.extras.forEach(extra => {
            arr.push(extra.name);
            })
        cartLog.extras = arr;
        analytics.logEvent('added_to_cart', cartLog);
    }
    // Called after a product has been added to cart
    let showSuccessToast = () => {
        document.getElementById('successAdded').hidden = false;
        document.getElementById('successAdded').classList.add('animate');
        successToastTimeout.current = setTimeout(() => {
            closeSuccessToast();
        }, 5500); // 5500 beacuse fadeOut is happening after 3.5 secs of delay and then 1.5 of the actual anim, sum = 5.5
    }
    // Used when the user wants to cloes the success toast
    let closeSuccessToast = () => {
        if (props.isAdmin) return; // irrelevent for admin panel
        document.getElementById('successAdded').hidden = true;
        document.getElementById('successAdded').classList.remove('animate');
        clearTimeout(successToastTimeout.current);
    }
    // Used when the user has his mouse over the motorcycle, to show "Avaiable for delivery"
    let showTooltipDelivery = (e) => {
        e.target.nextSibling.hidden = false;
        lastMovedOver.current = e.target.nextSibling;
        setTimeout(() => lastMovedOver.current.classList.add('active'), 20)
    }
    // Used when the user moves away his mouse off the motorcycle image
    let removeTooltipDelivery = (e) => {
        lastMovedOver.current.classList.remove('active');
        lastMovedOver.current.hidden = true;
    }
    // Used when clicked on "Go back to menu" from Admin Panel (This elem shows up only after entering a category)
    let goBackMenu = () => {
        document.getElementById('containerCategory').style.display = 'none';
        document.getElementById('chosenCategory').classList.remove('active');
        document.getElementById('goBackMenu').classList.remove('active');
        document.getElementById('gridContainer').hidden = false;
    }

    // Used for dynamic Title and description helmet
    let getProperTitle = (title) => {
        if (window.location.href.includes('/en')) { 
            let newTitle = title.slice(9, title.length);
            newTitle = newTitle.replace(/-/g, ' ');  
            return newTitle;
        } else {
            let newTitle = title.slice(6, title.length);
            newTitle = newTitle.replace(/-/g, ' ');  
            return newTitle;
        }
    }

    // If it was called from user tab, and not admin panel
    if (!props.isAdmin) {
        // In case a random name was provided that isn't a menu category, redirect the user to the menu
        if (props.history.location.state===undefined) {
            if (window.location.href.includes('/en')) {
                props.history.push({
                    pathname: '/en/menu',
                    state: {
                        title: getProperTitle(props.history.location.pathname),
                        english: true
                    }
                });
                props.history.go(0);
            } else {
                props.history.push({
                    pathname: '/menu',
                    state: {
                        title: getProperTitle(props.history.location.pathname)
                    }
                });
                props.history.go(0);
            }
            
        }
    }

    
    if (window.location.href.includes('/en')) { 
        return (
            <div id="menu">
            {!props.isAdmin &&
            <Helmet>
				<title>{getProperTitle(props.history.location.pathname)} (Menu) | Itay's Restaurant</title>
				<meta 
				name="description" 
				content={getProperTitle(props.history.location.pathname) + " category page. Itay's Restaurant makes a 'rise' to the best dishes in the world, presenting a menu of all worlds: Israeli, Italian, American, Far East, and Mexican in one restaurant."} />
			</Helmet>
            }

            {props.isAdmin==null ? 
            <Link to={{ pathname: '/en/menu', state: { menu: props.history.location.state.menu, cart: cart } }}><div id="goBackMenu"><span>Go Back Menu</span><img src={goBack}/></div></Link>
            : <div id="goBackMenu" onClick={goBackMenu}><span>Go Back Menu</span><img src={goBack}/></div>}
            

            <div id="chosenCategory">
                    <ul>
                        {chosenCategory.map((value, index) => 
                            <li key={value.productName + index}>
                                <div className="blackBackground"></div>
                                <img className="productPic" data-src={value.picURL} onClick={openEnlargedPic} alt={value.productName}/>
                                
                                <div className="productName">{value.productName}</div>
                                {value.noDelivery!=true && 
                                <React.Fragment>
                                <img className="yesDelivery" src={deliveryPic} alt="Available for delivery" onMouseOver={showTooltipDelivery} onMouseOut={removeTooltipDelivery}/>
                                <div className="deliveryTooltip" hidden>Available for delivery</div>
                                </React.Fragment>
                                }

                                {(value.desc!="") ? <div className="productDesc">{value.desc}</div> : <div className="noDesc">No description</div>}
                                <div className="price">{value.price}</div>
                                <button className="orderButton" onClick={orderNow}>Order Now <img src={cartPic} alt="cart pic"/> </button>

                                <div className="wantsOrder">
                                    <div className="orderWrapper">
                                        <img style={{position: 'absolute', right: '10px', top: '10px', width: '50px', zIndex: '999', cursor: 'pointer'}} onClick={closeOrder} src={xButton} alt="close button"/>

                                        <form name="newProdctToCart" style={{padding: '25px'}} onSubmit={(e) => e.preventDefault}>
                                            <div className="chosenProduct"> {value.productName} </div>
                                            <div className="options">
                                                <div className="titleOptionsExtras">Options {value.options.length!==0 && <span style={{fontSize: '25px'}}>(max picks: <span style={{color: 'red'}}>{value.maxpicks}</span>)</span>}</div>    
                                                {value.options.length===0 ? <div>No options available.</div> :
                                                    <React.Fragment>
                                                        {value.options.map((val, index) =>
                                                            <label htmlFor={getRemovedSpacesVal(val, value.productName)} key={val + index}>
                                                                <input type="checkbox" id={getRemovedSpacesVal(val, value.productName)} name={getRemovedSpacesVal(val, value.productName)} value={val} 
                                                                                                                    onChange={() => checkLimit(window.event, val, value.maxpicks)}/>
                                                                <span className="checkmark"></span>
                                                                <div className="WrapperName">{val}</div>
                                                            </label>
                                                        )}
                                                    </React.Fragment>
                                                }
                                            </div>  

                                            <div className="extras options">
                                                <div className="titleOptionsExtras">Extras</div>
                                                {value.extras.length==0 ? <div>No extras available.</div> :
                                                    <React.Fragment>
                                                        {value.extras.map((val, index) =>
                                                            <label htmlFor={getRemovedSpacesVal(val.name, value.productName)} key={val + index}>
                                                                <input type="checkbox" id={getRemovedSpacesVal(val.name, value.productName)} name={getRemovedSpacesVal(val.name, value.productName)} value={val.name} 
                                                                                                                    onChange={() => addExtras(window.event, val.name, val.price)}/>
                                                                <span className="checkmark"></span>
                                                                <div className="WrapperName">{val.name}</div>
                                                                <span className="extrasPrice">{val.price}</span>
                                                            </label>
                                                        )}
                                                    </React.Fragment>
                                                }
                                            </div>
                                            <button onClick={() => addProductToCart(window.event, value.price, value.productName, value.noDelivery)}><img src={cartPic} alt="cart"/>Add to cart!</button>
                                            <div className="PriceForThisProduct">{value.price}</div>
                                        </form>
                                    </div>
                                </div>
                            </li>
                        )}
                    </ul>
            </div>
            <div id="popUpEnlargedImage">
                <div id="EnlargedWrapper">
                    <img alt="the enlarged pic"/>
                    <img style={{position: 'absolute', right: '10px', top: '10px', width: '50px', zIndex: '999', cursor: 'pointer'}} onClick={closeEnlargedImage} src={xButton} alt="close button"/>
                </div>
            </div>
            <div id="brightnessLeft"></div>

            {props.isAdmin==null && <Cart cart={cart} setCart={setCart} closeSuccessToast={closeSuccessToast} forceUpdate={forceUpdate}/>} {/*// Showing My Cart only in case it was called as regular user on menu*/}
         </div>   
    )
}

// Else render it in english
     return ( 
        <div id="menu" className="hebrew">
            {!props.isAdmin &&
            <Helmet>
                <title>{getProperTitle(props.history.location.pathname)} (תפריט) | המסעדה של איתי</title>
                <meta 
                name="description" 
                content={getProperTitle(props.history.location.pathname) + "| קטגוריה בתפריט של המסעדה של איתי."} />
            </Helmet>
            }

            {props.isAdmin==null ? 
            <Link to={{ pathname: '/menu', state: { menu: props.history.location.state.menu, cart: cart } }}><div id="goBackMenu"><span>חזור לתפריט</span><img src={goBack}/></div></Link>
            : <div id="goBackMenu" onClick={goBackMenu}><span>חזור לתפריט</span><img src={goBack}/></div>}
            

            <div id="chosenCategory">
                    <ul>
                        {chosenCategory.map((value, index) => 
                            <li key={value.productName + index}>
                                <div className="blackBackground"></div>
                                <img className="productPic" data-src={value.picURL} onClick={openEnlargedPic} alt={value.productName}/>
                                
                                <div className="productName">{value.productName}</div>
                                {value.noDelivery!=true && 
                                <React.Fragment>
                                <img className="yesDelivery" src={deliveryPic} alt="Available for delivery" onMouseOver={showTooltipDelivery} onMouseOut={removeTooltipDelivery}/>
                                <div className="deliveryTooltip" hidden>זמין למשלוח</div>
                                </React.Fragment>
                                }

                                {(value.desc!="") ? <div className="productDesc">{value.desc}</div> : <div className="noDesc">אין תיאור</div>}
                                <div className="price">{value.price}</div>
                                <button className="orderButton" onClick={orderNow}>הזמן עכשיו <img src={cartPic} alt="cart pic"/> </button>

                                <div className="wantsOrder">
                                    <div className="orderWrapper">
                                        <img className="closeNewOrder" onClick={closeOrder} src={xButton} alt="close button"/>

                                        <form name="newProdctToCart" style={{padding: '25px'}} onSubmit={(e) => e.preventDefault}>
                                            <div className="chosenProduct"> {value.productName} </div>
                                            <div className="options">
                                                <div className="titleOptionsExtras">אופציות לבחירה{value.options.length!==0 && <span style={{fontSize: '25px'}}> (מקסימום אופציות: עד <span style={{color: 'red'}}>{value.maxpicks}</span>)</span>}</div>    
                                                {value.options.length===0 ? <div>אין אופציות לבחירה.</div> :
                                                    <React.Fragment>
                                                        {value.options.map((val, index) =>
                                                            <label htmlFor={getRemovedSpacesVal(val, value.productName)} key={val + index}>
                                                                <input type="checkbox" id={getRemovedSpacesVal(val, value.productName)} name={getRemovedSpacesVal(val, value.productName)} value={val} 
                                                                                                                    onChange={() => checkLimit(window.event, val, value.maxpicks)}/>
                                                                <span className="checkmark"></span>
                                                                <div className="WrapperName">{val}</div>
                                                            </label>
                                                        )}
                                                    </React.Fragment>
                                                }
                                            </div>  

                                            <div className="extras options">
                                                <div className="titleOptionsExtras">תוספות</div>
                                                {value.extras.length==0 ? <div>אין תוספות במנה זו.</div> :
                                                    <React.Fragment>
                                                        {value.extras.map((val, index) =>
                                                            <label htmlFor={getRemovedSpacesVal(val.name, value.productName)} key={val + index}>
                                                                <input type="checkbox" id={getRemovedSpacesVal(val.name, value.productName)} name={getRemovedSpacesVal(val.name, value.productName)} value={val.name} 
                                                                                                                    onChange={() => addExtras(window.event, val.name, val.price)}/>
                                                                <span className="checkmark"></span>
                                                                <div className="WrapperName">{val.name}</div>
                                                                <span className="extrasPrice">{val.price}</span>
                                                            </label>
                                                        )}
                                                    </React.Fragment>
                                                }
                                            </div>
                                            <button onClick={() => addProductToCart(window.event, value.price, value.productName, value.noDelivery)}><img src={cartPic} alt="cart"/>הוסף לסל!</button>
                                            <div className="PriceForThisProduct">{value.price}</div>
                                        </form>
                                    </div>
                                </div>
                            </li>
                        )}
                    </ul>
            </div>
            <div id="popUpEnlargedImage">
                <div id="EnlargedWrapper">
                    <img alt="the enlarged pic"/>
                    <img style={{position: 'absolute', right: '10px', top: '10px', width: '50px', zIndex: '999', cursor: 'pointer'}} onClick={closeEnlargedImage} src={xButton} alt="close button"/>
                </div>
            </div>
            <div id="brightnessLeft"></div>

            {props.isAdmin==null && <Cart cart={cart} setCart={setCart} closeSuccessToast={closeSuccessToast} forceUpdate={forceUpdate}/>} {/*// Showing My Cart only in case it was called as regular user on menu*/}
        </div>
     )
 } 

export default MenuCategory
